const colors = {
  grey: {
    50: '#FAFBFB',
    100: '#F2F3F4',
    200: '#E0E2E6',
    300: '#C2C6CE',
    400: '#A3A8B3',
    500: '#858C9B',
    600: '#626978',
    700: '#3C4049',
    800: '#25272D',
    900: '#131417'
  },
  blue: {
    50: '#F7F9FF',
    100: '#E8EFFE',
    200: '#C8DAFE',
    300: '#94B7FC',
    400: '#5B90FB',
    500: '#276DF9',
    600: '#054AD5',
    700: '#032D81',
    800: '#021C50',
    900: '#010E29'
  },
  yellow: {
    50: '#FFFFF7',
    100: '#FEFEE8',
    200: '#FEFEC8',
    300: '#FCFC94',
    400: '#FBFB5B',
    500: '#F9F927',
    600: '#B3B305',
    700: '#818103',
    800: '#505002',
    900: '#292901'
  },
  red: {
    50: '#FFF7F7',
    100: '#FEE9E8',
    200: '#FECCC8',
    300: '#FC8B83',
    400: '#FA3729',
    500: '#B81105',
    600: '#860C03',
    700: '#630903',
    800: '#500702',
    900: '#290401'
  },
  green: {
    50: '#F7FFFA',
    100: '#E8FEF1',
    200: '#C8FEDF',
    300: '#83FCB5',
    400: '#29FA80',
    500: '#05B84F',
    600: '#03863A',
    700: '#03632B',
    800: '#025022',
    900: '#012912'
  },
  teal: {
    50: '#F5FAFB',
    100: '#D6EDEE',
    200: '#97D0D5',
    300: '#6BBDC5',
    400: '#3DA9B4',
    500: '#0295A1',
    600: '#027E8A',
    700: '#036873',
    800: '#044047',
    900: '#031B1E'
  }
};
export default colors;